// extracted by mini-css-extract-plugin
export default {"list":"CardRows-module--list--f16dc"};